import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

import SelectInput from './SelectInput.react';

const StyledFormControl = styled(FormControl)(({ theme }) => {
  return {
    minWidth: 120,
    margin: theme.spacing(1),
  };
});

const LabelledSelectInput = ({
  label,
  options,
  selectedValue,
  onChange,
  ...other
}) => {
  return (
    <StyledFormControl {...other}>
      <InputLabel htmlFor="select-input">{label}</InputLabel>
      <SelectInput
        id="select-input"
        options={options}
        selectedValue={selectedValue}
        onChange={onChange}
      />
    </StyledFormControl>
  );
};

LabelledSelectInput.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default LabelledSelectInput;
